function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  id: "_001-calendar",
  "data-name": "001-calendar",
  d: "M22.98,3.283H21.886V1.094A1.1,1.1,0,0,0,20.791,0H19.7A1.1,1.1,0,0,0,18.6,1.094V3.283H7.66V1.094A1.1,1.1,0,0,0,6.566,0H5.471A1.1,1.1,0,0,0,4.377,1.094V3.283H3.283A3.287,3.287,0,0,0,0,6.566V22.98a3.287,3.287,0,0,0,3.283,3.283h19.7a3.287,3.287,0,0,0,3.283-3.283V6.566A3.287,3.287,0,0,0,22.98,3.283Zm1.094,19.7a1.1,1.1,0,0,1-1.094,1.094H3.283A1.1,1.1,0,0,1,2.189,22.98V10.987H24.074Zm0,0"
});

var SvgBooking = function SvgBooking(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 26.262,
    height: 26.262,
    viewBox: "0 0 26.262 26.262",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBooking, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Booking.f9e334ae.svg";
export { ForwardRef as ReactComponent };